const _camelize = (str, first) => {
  str = str.replace(/-(\w)/g, (_, c) => c ? c.toUpperCase() : '')

  if (first == 'lower') {
    str = str[0].toLowerCase() + str.substr(1)
  } else if (first == 'upper') {
    str = str[0].toUpperCase() + str.substr(1)
  }

  return str
}

export default _camelize
